import { SearchInput } from '@kanda-libs/ks-component-ts';

import InfoBanner from 'components/shared/InfoBanner';
import PageTitle from 'components/shared/PageTitle';
import useQuery from 'hooks/useQuery';

export interface RateRequestListPageBannerProps {}

const RateRequestListPageBanner: React.FunctionComponent<RateRequestListPageBannerProps> =
  function ({}) {
    const [query, setQuery] = useQuery('rateRequests');
    return (
      <>
        <PageTitle>Rate Requests</PageTitle>
        <InfoBanner
          title="Rate Requests"
          backArrow={false}
          search={<SearchInput query={query} onSearch={setQuery} />}
        />
      </>
    );
  };

export default RateRequestListPageBanner;
